// test1551
(1551 && 0);
